/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Actionsheet from "vux/src/components/actionsheet/index.vue"; // this line is trasformed by vux-loader
var ComponentsClass = Vue.extend(Actionsheet);
var div = document.createElement('div');
var ComponentsVnode = new ComponentsClass({
  propsData: {
    value: false,
    showCancel: true,
    menus: []
  }
}).$mount(div);
document.body.appendChild(ComponentsVnode.$el);
function update(data) {
  for (var key in data) {
    ComponentsVnode.$props[key] = data[key];
  }
}

// Listen for the 'input' event to sync the value prop
// This effectively re-implements v-model programmatically.
ComponentsVnode.$on('input', function (newValue) {
  // When the actionsheet closes itself, it emits 'input' with `false`.
  // We update our prop here to keep the state in sync.
  ComponentsVnode.$props.value = newValue;
});
function showActionSheet(_ref) {
  var _ref$menus = _ref.menus,
    menus = _ref$menus === void 0 ? [] : _ref$menus;
  update({
    menus: menus,
    value: true
  });
  return ComponentsVnode;
}
var install = function install(Vue) {
  Vue.prototype.$showActionSheet = showActionSheet;
};
export { showActionSheet };
export default install;